import React from 'react';
import PropTypes from 'prop-types';
import { Button, Steps } from 'antd';
import moment from 'moment';
import Paragraph from '../../../../components/common/Paragraph';
import './styles.less';

const EnrollmentHistory = ({ enrollmentHistory, onFinish }) => {
  const isInProgress = !enrollmentHistory[enrollmentHistory.length - 1] === 'IN_PROGRESS';

  return (
    <div className="enrollment-history">
      <Paragraph strong noBottomMargin>
        Estado de solicitud
      </Paragraph>
      <Paragraph>{enrollmentHistory[enrollmentHistory.length - 1]?.description}</Paragraph>
      <Steps direction="vertical" current={enrollmentHistory.length - 1}>
        {enrollmentHistory.map((status) => (
          <Steps.Step
            key={status.date}
            title={`${status.name} - ${moment(status.date).format('DD/MM/YYYY')}`}
          />
        ))}
        {isInProgress && <Steps.Step title="Solicitud aceptada" />}
      </Steps>
      <Button type="primary" onClick={onFinish} block style={{ marginTop: '2rem' }}>
        Aceptar
      </Button>
    </div>
  );
};

EnrollmentHistory.propTypes = {
  enrollmentHistory: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onFinish: PropTypes.func.isRequired,
};

export default EnrollmentHistory;
